import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { Container, TabContent, TabPane, Row, Col } from 'reactstrap'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import moment from 'moment'

import KawariHelper from '../../components/calendar/helper'

import {
  authAction,
  leaveTypeAction,
  publicHolidayAction,
  teamCalendarAction,
} from './../../actions/'

import {
  authSelector,
  leaveTypeSelector,
  publicHolidaySelector,
  teamCalendarSelector,
} from './../../selectors'

import withLayout from '../../helpers/withLayout'
import { Calendar } from '../../components/calendar'
import Searchbar from '../../components/searchbar-team-calendar'

const NewTeamCalendarPage = () => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const isFetchingTeamCalendar = useSelector(teamCalendarSelector.getIsFetching)
  const isFetchingLeaveType = useSelector(leaveTypeSelector.getIsFetching)
  const isFetchingPublicHoliday = useSelector(publicHolidaySelector.getIsFetching)
  const isFetching = isFetchingTeamCalendar || isFetchingLeaveType || isFetchingPublicHoliday

  const user = useSelector(authSelector.getUserData)
  const authenticated = useSelector(authSelector.redirectAuth)
  const redirect = authenticated.redirect

  const _moment = useSelector(teamCalendarSelector.getMoment)
  const activeTab = useSelector(teamCalendarSelector.getTab)
  const allRequests = useSelector(teamCalendarSelector.getTeamCalendar)
  const publicHoliday = useSelector(publicHolidaySelector.getPublicHolidayData)
  const search = useSelector(teamCalendarSelector.getSearch)

  const IsSystemUser = user.is_system_admin
  const IsHRConfidentialUser = user.is_hr_admin_confidential_role
  const IsLOBLeadUser = user.is_lob_lead_role
  const IsManagementUser = user.is_management_role
  const isAuthenticated = authenticated.isAuthenticated

  const leaveRequestsByLob = allRequests ? allRequests.leaveRequestsGroupByLob : {}
  const compensateRequestByLob = allRequests ? allRequests.compensateRequestGroupByLob : {}
  const users = allRequests ? allRequests.users : []
  const lobs = allRequests ? allRequests.lobs : []

  useEffect(() => {
    fetchAPIs()
  }, [])

  const fetchAPIs = async () => {
    await Promise.all([
      dispatch(authAction.auth(access_token)),
      dispatch(teamCalendarAction.getTeamCalendar(moment().format('YYYY-MM-DD'), access_token)),
      dispatch(leaveTypeAction.getLeaveType(access_token)),
      dispatch(publicHolidayAction.getPublicHoliday(access_token)),
    ])
  }

  const searchLeaveRequest = (data) => {
    const s = search.toLowerCase()
    if (data) {
      if (search === '') return data
      return data.filter(el => {
        const name = (el.row_label || '').toLowerCase()
        const group = (el.group_label || '').toLowerCase()
        return name.includes(s) || group.includes(s)
      })
    }
    return data
  }

  const findLobName = (id) => {
    const lob = lobs.find(l => l._id === id)
    return lob ? lob.name : ''
  }

  const findFullNameByID = (id) => {
    const user = users.find(u => u._id === id)
    return user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : ''
  }

  const onMomentChange = (m) => {
    dispatch(teamCalendarAction.getTeamCalendar(moment(m).format('YYYY-MM-DD'), access_token))
    dispatch(teamCalendarAction.setMomentTeamCalendar(m))
  }

  const onRangeChange = (r) => dispatch(teamCalendarAction.setRangeTeamCalendar(r))

  const handleSearch = (e) => dispatch(teamCalendarAction.setSearchTeamCalendar(e))

  const handleTab = (tab) => dispatch(teamCalendarAction.setTabTeamCalendar(tab))

  const events = KawariHelper.createTableMetrolendarEvents(
    leaveRequestsByLob, true, findLobName)
  const compensate = KawariHelper.createCompensateTableMetrolendarEvents(
    compensateRequestByLob, true, findLobName, findFullNameByID)
  const summary = KawariHelper.createTableMetrolendarSummary(
    leaveRequestsByLob, true)
  const publicHolidays = KawariHelper.createListMetrolendarPublicHoliday(publicHoliday)
  const sumevents = [...events, ...compensate]

  const _events = searchLeaveRequest(sumevents)

  if (redirect) {
    localStorage.clear()
    if (isAuthenticated) localStorage.setItem('bad_token', true)
    dispatch(authAction.resetAuth())
    window.location = '/'
  }
  if (IsLOBLeadUser !== undefined &&
    IsSystemUser !== undefined &&
    IsHRConfidentialUser !== undefined &&
    IsManagementUser !== undefined &&
    !(IsLOBLeadUser || IsSystemUser || IsHRConfidentialUser || IsManagementUser)) window.location = '/home'

  return (
    <Root fluid>
      <Searchbar
        activeTab={ activeTab }
        teamCalendar={ true }
        moment={ _moment }
        onMomentChange={ onMomentChange }
        onRangeChange={ onRangeChange }
        toggle={ handleTab }
        handleSearch={ handleSearch }
      />
      { isFetching &&
        <Overlay>
          <OverlayWrapper>
            <BeatLoader
              css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
              sizeUnit={ "px" }
              size={ 15 }
              color={ '#D44B49' }
              loading={ isFetching }
            />
          </OverlayWrapper>
        </Overlay>
      }
      { !isFetching && (
        <TabContent activeTab={ '1' }>
          <TabPane tabId="1">
            <Row>
              <Col>
                <CalendarWrapper>
                  <Calendar
                    events={ _events }
                    summary={ summary }
                    publicHolidays={ publicHolidays }
                  />
                </CalendarWrapper>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      )}
    </Root>
  )
}

export default withLayout(NewTeamCalendarPage)

const Root = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
  position: relative;
  width: 100%;
`

const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`

const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/new-team-calendar/index.js